var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 64,
    viewBox: "0 0 76 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5001 26.7728L11.1194 46.7759C10.5179 47.1003 10.5136 47.9617 11.1118 48.292L26.7445 56.925C30.8216 59.1766 35.7587 59.2227 39.8772 57.0477L76.0001 43.1819V44.0455L42.297 61.6299C36.634 64.6204 29.8456 64.557 24.2395 61.4611L8.60683 52.8281C4.4192 50.5156 4.44921 44.4859 8.65963 42.2151L47.5001 25.9092V26.7728Z",
    fill: "#9CA6AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0683 26.3412L11.1194 45.9124C10.5179 46.2368 10.5136 47.0982 11.1118 47.4286L26.7445 56.0615C30.8216 58.3131 35.7587 58.3592 39.8772 56.1843L68.2274 42.3184L76.0001 43.1821L42.297 60.7664C36.634 63.757 29.8456 63.6935 24.2395 60.5976L8.60683 51.9647C4.4192 49.6521 4.44921 43.6224 8.65963 41.3516L39.8772 25.4775L47.0683 26.3412Z",
    fill: "url(#paint0_linear_2_32093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7725 3.88619V26.5566L39.7271 25.4771L40.1589 0.431641L45.7725 3.88619Z",
    fill: "url(#paint1_linear_2_32093)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2233 0.205564C40.3483 0.00245494 40.6143 -0.0608729 40.8174 0.0641173L46.6365 3.64513L47.5001 26.1325L45.7729 26.9962V4.12772L40.3647 0.79964C40.1616 0.67465 40.0983 0.408673 40.2233 0.205564Z",
    fill: "url(#paint2_linear_2_32093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2725 20.2954V43.1817L68.2271 42.3181L68.6589 16.8408L74.2725 20.2954Z",
    fill: "url(#paint3_linear_2_32093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2725 20.2954L34.9771 42.3181L28.9316 38.4317L68.6589 16.8408L74.2725 20.2954Z",
    fill: "url(#paint4_linear_2_32093)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7725 3.88619L6.47709 25.9089L0.431641 22.0225L40.1589 0.431641L45.7725 3.88619Z",
    fill: "url(#paint5_linear_2_32093)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7732 3.88668L45.7729 10.7959C44.9396 7.33392 43.1933 5.64063 40.1593 6.90953L45.7732 3.88668Z",
    fill: "#61676A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2732 20.2949L74.2729 27.2041C73.4396 23.7421 71.6933 22.0488 68.6593 23.3177L74.2732 20.2949Z",
    fill: "#61676A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1435 31.8852L34.9689 35.1619C35.2408 35.3149 35.4091 35.6027 35.4091 35.9147V42.0121C35.4091 42.3424 35.0534 42.5504 34.7656 42.3885L28.9402 39.1117C28.6683 38.9588 28.5 38.671 28.5 38.359V32.2615C28.5 31.9313 28.8557 31.7233 29.1435 31.8852Z",
    fill: "url(#paint6_linear_2_32093)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.643522 15.476L6.46886 18.7528C6.7408 18.9057 6.90909 19.1935 6.90909 19.5055V25.603C6.90909 25.9332 6.55342 26.1412 6.26557 25.9793L0.440229 22.7026C0.16829 22.5496 0 22.2618 0 21.9498V15.8524C0 15.5221 0.355671 15.3141 0.643522 15.476Z",
    fill: "url(#paint7_linear_2_32093)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4092 42.3181V35.8408C36.2728 39.2954 38.0001 40.159 41.0228 38.8635L35.4092 42.3181Z",
    fill: "#61676A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90918 25.9089V19.4316C7.77282 22.8862 9.50009 23.7498 12.5228 22.4544L6.90918 25.9089Z",
    fill: "#61676A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7172 4.10711C45.834 4.31503 45.7602 4.57828 45.5523 4.69509L7.12045 26.286C6.91253 26.4028 6.64928 26.3289 6.53247 26.121C6.41566 25.9131 6.48952 25.6499 6.69744 25.533L45.1293 3.94214C45.3372 3.82533 45.6004 3.89919 45.7172 4.10711Z",
    fill: "#737E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2172 20.5163C74.334 20.7242 74.2602 20.9875 74.0523 21.1043L35.6204 42.6952C35.4125 42.812 35.1493 42.7381 35.0325 42.5302C34.9157 42.3223 34.9895 42.059 35.1974 41.9422L73.6293 20.3513C73.8372 20.2345 74.1004 20.3084 74.2172 20.5163Z",
    fill: "#737E87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7233 16.6147C68.8483 16.4116 69.1143 16.3483 69.3174 16.4733L75.1365 20.0543L76.0001 43.1819L74.2729 44.0455V20.5369L68.8647 17.2088C68.6616 17.0838 68.5983 16.8179 68.7233 16.6147Z",
    fill: "url(#paint8_linear_2_32093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_32093",
    x1: 49.6593,
    y1: 32.8185,
    x2: 17.2729,
    y2: 57.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33393C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E6468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_32093",
    x1: 43.1816,
    y1: 3.45437,
    x2: 43.1816,
    y2: 26.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42474A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_32093",
    x1: 41.0228,
    y1: -1.26269e-8,
    x2: 43.8296,
    y2: 26.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48555F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_32093",
    x1: 71.6816,
    y1: 19.8635,
    x2: 71.6816,
    y2: 42.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42474A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_32093",
    x1: 68.6589,
    y1: 16.8408,
    x2: 33.2498,
    y2: 37.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55595C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_32093",
    x1: 40.1589,
    y1: 0.431639,
    x2: 4.74982,
    y2: 21.5907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55595C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_32093",
    x1: 31.9545,
    y1: 31.5232,
    x2: 31.9545,
    y2: 42.7504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_32093",
    x1: 3.45455,
    y1: 15.114,
    x2: 3.45455,
    y2: 26.3413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_32093",
    x1: 69.5228,
    y1: 16.4092,
    x2: 72.3296,
    y2: 43.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48555F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStand);
export default __webpack_public_path__ + "static/media/LaptopStand.9d512fb297e3b3edd8aa7ab6dee233a6.svg";
export { ForwardRef as ReactComponent };